import { useNotification } from '../contexts/NotificationContext';
import { logger } from '../utils/logger';

interface ErrorResult {
  message: string;
  code?: string;
  details?: any;
}

export const useErrorHandler = () => {
  const { showError } = useNotification();

  const handleApiError = (error: any, defaultMessage?: string): ErrorResult => {
    logger.error('[Error Handler]', error);

    let errorMessage = defaultMessage || 'Došlo je do greške';
    let errorCode: string | undefined;
    let errorDetails: any;

    if (error?.response) {
      // HTTP error response
      const status = error.response.status;
      const data = error.response.data;

      switch (status) {
        case 400:
          errorMessage = data?.message || 'Neispravni podaci';
          break;
        case 401:
          errorMessage = 'Nemate dozvolu za ovu akciju';
          break;
        case 403:
          errorMessage = 'Pristup zabranjen';
          break;
        case 404:
          errorMessage = 'Traženi resurs nije pronađen';
          break;
        case 409:
          errorMessage = data?.message || 'Konflikt podataka';
          break;
        case 422:
          errorMessage = data?.message || 'Podaci nisu validni';
          break;
        case 500:
          errorMessage = 'Greška na serveru';
          break;
        default:
          errorMessage = data?.message || `HTTP ${status} greška`;
      }

      errorCode = status.toString();
      errorDetails = data;
    } else if (error?.request) {
      // Network error
      errorMessage = 'Greška u komunikaciji sa serverom';
      errorCode = 'NETWORK_ERROR';
    } else if (error?.message) {
      // JavaScript error
      errorMessage = error.message;
      errorCode = 'JS_ERROR';
    }

    // Show error notification
    showError(errorMessage);

    return {
      message: errorMessage,
      code: errorCode,
      details: errorDetails
    };
  };

  const handleError = (error: Error, context?: string): ErrorResult => {
    const contextPrefix = context ? ` - ${context}` : '';
    logger.error(`[Error Handler${contextPrefix}]`, error);

    const errorMessage = error.message || 'Došlo je do neočekivane greške';
    showError(errorMessage);

    return {
      message: errorMessage,
      code: 'GENERAL_ERROR',
      details: error
    };
  };

  return {
    handleApiError,
    handleError
  };
};
